import { DEFAULT_ERROR_MESSAGE } from 'src/constants';

export const CUSTOM_LANG_PARAMS: { [key: string]: string } = {
  invalid_login_or_password: 'Incorrect current password',
  password_does_not_meet_complexity_requirements:
    'Password must contain at least 8 characters, a letter and a number',
  passwords_do_not_match: 'Your passwords must match',
};

export const PASSWORD_STATUS_TEXT: { [key: string]: string } = {
  incorrect_current_password_error: 'Incorrect current password.',
  recently_used_password_error:
    "You've already used that password. Please create a new one.",
  internal_api_error: DEFAULT_ERROR_MESSAGE,
  successful: 'Password was updated.',
};
